var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-mobile"},[_c('router-link',{staticClass:"ajouter",attrs:{"to":{ name: 'visites.create', params: {
            ruche_id: _vm.$route.params.id
         } }}},[_c('b-icon',{attrs:{"icon":"plus-circle"}}),_vm._v("Enregistrer une nouvelle visite ")],1)],1),_c('BlocInfos'),_c('BlocVisites'),_c('BlocTaches')],1)}
var staticRenderFns = []

export { render, staticRenderFns }